type Breadcrumb = {
  name: string;
  relativeLink?: string;
};

export const getBreadcrumbsLDJSONString = (host: string, breadcrumbs: Breadcrumb[]): string => {
  return JSON.stringify({
    ['@context']: 'https://schema.org',
    ['@type']: 'BreadcrumbList',
    itemListElement: breadcrumbs.map((breadcrumb, idx) =>
      breadcrumb.relativeLink
        ? {
            ['@type']: 'ListItem',
            position: idx + 1,
            name: breadcrumb.name,
            item: `${host}${breadcrumb.relativeLink}`,
          }
        : {
            ['@type']: 'ListItem',
            position: idx + 1,
            name: breadcrumb.name,
          }
    ),
  });
};
